import React, { Component } from 'react';
import _ from 'underscore';

import NumericInput from './NumericInput.js';


class NumericInputContainer extends Component {
    constructor(props){
        super(props);
        this.initialState = {value:'', valid:false};
        this.state = this.initialState;
        this.onSubmit = this.onSubmit.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    onComplete() {
        if(this.state.valid) {
            if(this.props.onComplete) {
                this.props.onComplete({value:this.state.value});
            }
        }
    }
    onChange(event) {
        this.setState({value:event.target.value, valid:this.isValid(event.target.value)});
    }
    isValid(value) {
        return _.isFinite(parseInt(value));
    }
    onSubmit(event) {
        this.onComplete();
        event.preventDefault();
    }
    
    render() {
        console.log(typeof this.state.value);
        var challenge = this.props.challenge;
        return <NumericInput
                   {...this.props}
                   challenge={challenge}
                   onComplete={this.onComplete}
                   onSubmit={this.onSubmit}
                   onChange={this.onChange}
                   value={this.state.value}
                   valid={this.state.valid}
                   completePending={this.props.completePending}
                   />;
    }

}

export default NumericInputContainer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/screens/NumericInputContainer.js